module.exports = __webpack_public_path__ + "static/media/lt.7e3fe92f.svg";